/*global _ */

/* DIS/PLAY Script
 Author's name: Dan Sørensen
 Modified by:
 Client name: ...
 Date of creation: ...
 */

var dis = dis || {};

(function (dis) {
	"use strict";

	dis.BaseModule.prototype.getUrlParameter = function(sParam) {
		var sPageURL = window.location.search.substring(1),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			i;

		for (i = 0; i < sURLVariables.length; i = i + 1) {
			sParameterName = sURLVariables[i].split('=');
			if (sParameterName[0] === sParam) {
				return typeof sParameterName[1] === undefined ? true : sParameterName[1] === "" ? false : decodeURIComponent(sParameterName[1]);
			}
		}
		return false;
	};

}(dis, _));